/**
 * Auth api script file
 *
 * @package    Api
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2017 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com Commercial
 * @link       http://mindk.com
 */

export default class AuthApi {
    /**
     * Send request for login user to system
     *
     * @param {Object} data
     *
     * @returns {Object}
     */
    static login(data) {
        return axios => axios.post('/users/login', data);
    }

    /**
     * Send request for login in social networks
     *
     * @param {Object} data
     *
     * @returns {Object}
     */
    static loginSocial(data) {
        return axios => axios.post(`/users/social/login/${data.social}`, data);
    }

    /**
     * Send request for login in social networks
     *
     * @param {Object} data
     *
     * @returns {Object}
     */
    static registerSocial(data) {
        return axios => axios.post(`/users/social/register/${data.social}`, data);
    }

    /**
     * Logout a user with access token.
     *
     * @returns {Object}
     */
    static logout() {
        return axios => axios.post('/users/logout');
    }

    /**
     * Send request for keep alive user
     *
     * @returns {Object}
     */
    static keepAlive() {
        return axios => axios.get('/users/keep-alive');
    }

    /**
     * Send request for registration
     * @param data
     * @returns {Object}
     */
    static register(data) {
        return axios => axios.post('/users/register', data);
    }

    /**
     * Send request for quick registration
     *
     * @param token
     * @param data
     * @returns {Object}
     */
    static registerQuick(token, data) {
        return axios => axios.post(`/users/register/${token}`, data);
    }

    /**
     * Send request for reset password
     * @param data
     * @returns {Object}
     */
    static recoverPassword(data) {
        return axios => axios.post('/users/reset/request', data);
    }

    /**
     * Send request for check token expire
     * @param token
     * @returns {Object}
     */
    static resetPasswordCheckToken(token) {
        return axios => axios.get(`/users/reset/${token}`);
    }

    /**
     * Send request for confirm reset password
     * @param data
     * @returns {Object}
     */
    static resetPassword(data) {
        return axios => axios.post('/users/reset/confirm', data);
    }

    /**
     * @param token
     * @returns {Object}
     */
    static checkResetPasswordToken(token) {
        return axios => axios.get(`/users/reset/check/${token}`);
    }

    /**
     * Verify email
     * @param token
     * @returns {Object}
     */
    static emailVerify(token) {
        return axios => axios.post('/users/email/verify', { token });
    }
}



// WEBPACK FOOTER //
// ./src/api/auth.js